import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { getRankHoverBorderClass } from "@/components/waves/drops/dropRankStyles";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropMobileMenuCopyLink from "@/components/waves/drops/WaveDropMobileMenuCopyLink";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import React from "react";
import { createPortal } from "react-dom";
import { WaveWinnersDropHeader } from "./header/WaveWinnersDropHeader";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
import WaveWinnersDropHeaderTotalVotes from "./header/WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./header/WaveWinnersDropHeaderVoters";
import WaveWinnersDropOutcome from "./header/WaveWinnersDropOutcome";
import { WaveWinnersDropContent } from "./WaveWinnersDropContent";
import { WaveWinnerIdentity } from "../identity/WaveWinnerIdentity";
interface DefaultWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isApprovalWave?: boolean | undefined;
}
const getRankHoverClass = (place: number | null): string => {
  return getRankHoverBorderClass(place);
};
const isClickFromCardDom = (event: React.MouseEvent<HTMLDivElement>): boolean => {
  return event.currentTarget.contains(event.target as Node);
};
export const DefaultWaveWinnersDrop: React.FC<DefaultWaveWinnersDropProps> = t0 => {
  const $ = _c(65);
  const {
    winner,
    onDropClick,
    isApprovalWave: t1
  } = t0;
  const isApprovalWave = t1 === undefined ? false : t1;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const suppressNextClickRef = React.useRef(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      suppressNextClickRef.current = true;
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleInteractionStart = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event => {
      if (!isClickFromCardDom(event)) {
        return;
      }
      if (!suppressNextClickRef.current) {
        return;
      }
      suppressNextClickRef.current = false;
      event.preventDefault();
      event.stopPropagation();
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClickCapture = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      suppressNextClickRef.current = false;
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleMenuClickCapture = t4;
  let t5;
  if ($[3] !== hasTouchScreen) {
    t5 = {
      hasTouchScreen,
      onInteractionStart: handleInteractionStart,
      preventDefault: false
    };
    $[3] = hasTouchScreen;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t5);
  let t6;
  if ($[5] !== setIsActive) {
    t6 = nextIsActive => {
      if (!nextIsActive) {
        suppressNextClickRef.current = false;
      }
      setIsActive(nextIsActive);
    };
    $[5] = setIsActive;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleMobileMenuOpenChange = t6;
  let t7;
  if ($[7] !== handleMobileMenuOpenChange) {
    t7 = () => {
      handleMobileMenuOpenChange(false);
    };
    $[7] = handleMobileMenuOpenChange;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleMobileMenuClose = t7;
  let t8;
  if ($[9] !== winner.drop) {
    t8 = convertApiDropToExtendedDrop(winner.drop);
    $[9] = winner.drop;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const extendedDrop = t8;
  let t9;
  if ($[11] !== extendedDrop || $[12] !== onDropClick) {
    t9 = event_0 => {
      if (!isClickFromCardDom(event_0)) {
        return;
      }
      onDropClick(extendedDrop);
    };
    $[11] = extendedDrop;
    $[12] = onDropClick;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleClick = t9;
  const userContextRating = winner.drop.context_profile_context?.rating ?? 0;
  const hasUserVoted = userContextRating !== 0;
  const userVote = userContextRating;
  const isUserVoteNegative = userVote < 0;
  const creditType = WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type] || "votes";
  let t10;
  if ($[14] !== isApprovalWave || $[15] !== winner.place) {
    t10 = isApprovalWave ? "desktop-hover:hover:tw-border-iron-700" : getRankHoverClass(winner.place);
    $[14] = isApprovalWave;
    $[15] = winner.place;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `tw-group tw-cursor-pointer tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 ${t10}`;
  let t12;
  if ($[17] !== winner) {
    t12 = <WaveWinnersDropHeaderAuthorPfp winner={winner} />;
    $[17] = winner;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== isApprovalWave || $[20] !== winner) {
    t13 = <WaveWinnersDropHeader winner={winner} showVotingInfo={false} isApprovalWave={isApprovalWave} />;
    $[19] = isApprovalWave;
    $[20] = winner;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== winner) {
    t14 = <WaveWinnersDropContent winner={winner} isCompetitionDrop={true} />;
    $[22] = winner;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = <div className="tw-flex tw-w-full tw-flex-col tw-gap-y-2">{t13}{t14}</div>;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t12 || $[28] !== t15) {
    t16 = <div className="tw-flex tw-flex-1 tw-gap-x-3">{t12}{t15}</div>;
    $[27] = t12;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== extendedDrop || $[31] !== hasTouchScreen) {
    t17 = !hasTouchScreen && <div className="tw-flex tw-flex-shrink-0 tw-items-start"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
    $[30] = extendedDrop;
    $[31] = hasTouchScreen;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <div className="tw-relative tw-z-10 tw-flex tw-w-full tw-justify-between tw-gap-x-3 tw-border-0 tw-bg-transparent tw-text-left">{t16}{t17}</div>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== winner.drop) {
    t19 = <WaveWinnerIdentity drop={winner.drop} variant="full" cardVariant="chat" />;
    $[36] = winner.drop;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== winner) {
    t20 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 tw-pt-2"><div className="tw-flex tw-items-center tw-gap-x-4 tw-whitespace-nowrap"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div><div><WaveWinnersDropOutcome winner={winner} /></div></div>;
    $[38] = winner;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== creditType || $[41] !== hasUserVoted || $[42] !== isUserVoteNegative || $[43] !== userVote) {
    t21 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-font-normal tw-text-iron-400">{creditType}</span></span></div></div>;
    $[40] = creditType;
    $[41] = hasUserVoted;
    $[42] = isUserVoteNegative;
    $[43] = userVote;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t19 || $[46] !== t20 || $[47] !== t21) {
    t22 = <div className="tw-ml-[3.25rem]"><div className="tw-flex tw-flex-col tw-gap-y-2">{t19}{t20}{t21}</div></div>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t18 || $[50] !== t22 || $[51] !== touchHandlers) {
    t23 = <div className="tw-rounded-xl tw-p-4" {...touchHandlers}>{t18}{t22}</div>;
    $[49] = t18;
    $[50] = t22;
    $[51] = touchHandlers;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== extendedDrop || $[54] !== handleMobileMenuClose || $[55] !== handleMobileMenuOpenChange || $[56] !== hasTouchScreen || $[57] !== isActive || $[58] !== setIsActive) {
    t24 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={handleMobileMenuOpenChange}><div onClickCapture={handleMenuClickCapture} className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={handleMobileMenuClose} /><WaveDropMobileMenuCopyLink drop={extendedDrop} onCopy={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[53] = extendedDrop;
    $[54] = handleMobileMenuClose;
    $[55] = handleMobileMenuOpenChange;
    $[56] = hasTouchScreen;
    $[57] = isActive;
    $[58] = setIsActive;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== handleClick || $[61] !== t11 || $[62] !== t23 || $[63] !== t24) {
    t25 = <div onClickCapture={handleClickCapture} onClick={handleClick} className={t11}>{t23}{t24}</div>;
    $[60] = handleClick;
    $[61] = t11;
    $[62] = t23;
    $[63] = t24;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  return t25;
};